<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <ng-container formGroupName="loan">
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Nom du crédit" [derrors]="derrors">
                      <input
                        formControlName="label"
                        type="text"
                        placeholder="Exemple : Crédit immobilier"
                      />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Catégorie" [derrors]="derrors">
                      <pr-select-search
                        formControlName="category"
                        [options]="loansCategoriesRefs"
                        label="Catégorie"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Banque" [derrors]="derrors">
                      <pr-select-search
                        formControlName="providerId"
                        [options]="providers"
                        label="Banque"
                        optionDisplayKey="name"
                        (selectionChange)="onBanqueChange($event)"
                      />
                    </pr-input-column>
                  </div>
                </div>
                @if (form.get('products').value[0].parameters.loan.providerId) {
                  <div class="row">
                    <div class="col-md-12">
                      <pr-input-column
                        label="Agence bancaire"
                        [derrors]="derrors"
                      >
                        <pr-select-search
                          formControlName="agenceBancaireId"
                          [options]="agencesBancairesFiltered"
                          label="Agence bancaire"
                          [displayFn]="displayAgenceBancaire"
                        />
                      </pr-input-column>
                    </div>
                  </div>
                }
                <div class="row">
                  <div class="col-md-12">
                    <!-- Détenteurs + part de détention (owners). `ownerIds` déprécié. -->
                    <pr-input-owner-share
                      formControlName="owners"
                      [derrors]="derrors"
                    ></pr-input-owner-share>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
                    <pr-input-date
                      formControlName="signatureDate"
                      label="Date de signature de l'offre de prêt"
                      [derrors]="derrors"
                    ></pr-input-date>
                  </div>
                </div>
                @if (
                  form.get('products').value[0].parameters
                    .borrowerInsuranceContext === 'CHANGE'
                ) {
                  <div class="row mt-1">
                    <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
                      <pr-input-date
                        formControlName="firstDueDate"
                        label="Date de la première échéance de prêt"
                        [derrors]="derrors"
                      ></pr-input-date>
                    </div>
                  </div>
                }
                <div class="row mt-1">
                  <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
                    <pr-input-date
                      formControlName="effectiveDate"
                      [label]="
                        form.get('products').value[0].parameters
                          .borrowerInsuranceContext === 'CHANGE'
                          ? 'Date d\'effet souhaitée'
                          : 'Date d\'effet'
                      "
                      [derrors]="derrors"
                    ></pr-input-date>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
